import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { RunLcaOnProducts } from "@tfg/types/schemas/modules/lifeCycleAnalysis/queries/run-lca-on-products"

import { useRunLcaOnProductsMutation } from "~/pages/Brand/Regulations/LCA/hooks/useRunLcaOnProductsMutation.ts"

interface Props {
  params: RunLcaOnProducts
}
export const RunLcaOnProductsButton = ({ params }: Props) => {
  const { mutate, isPending: isLoading } = useRunLcaOnProductsMutation()
  const { t } = useTranslation("regulations")
  return (
    <Button
      disabled={params.productIds.length === 0}
      onClick={() => {
        mutate(params)
      }}
      loading={isLoading}
    >
      {t("runLcaOnProducts", { count: params.productIds.length })}
    </Button>
  )
}
